<!-- @format -->

<div class="hmf-w-100">
	@for (item of [0, 0, 0]; track $index) {
		<div class="skeleton-specs-item hmf-w-100 hmf-p-s">
			<div class="hmf-w-100">
				<hmf-skeleton
					[loading]="true"
					width="40%"
					height="12px"
					class="hmf-mb-xxs"></hmf-skeleton>
				<hmf-skeleton
					[loading]="true"
					width="60%"
					[height]="
						breakpointsService.breakpoint() < BreakPointNew.SMALL ? '14px' : '16px'
					"></hmf-skeleton>
			</div>
		</div>
	}
</div>
